import { Text } from '@thanx/uikit/text'
import { useStyletron } from 'baseui'
import { Label2 } from 'baseui/typography'
import { buildTranslate } from 'locales'
import { Link } from 'react-router-dom'
import { merchantTheme } from 'theme'
interface ReportItemProps {
  id: string
  title: string
  description: string
}

const ReportItem = ({ id, title, description }: ReportItemProps) => {
  const [css] = useStyletron()
  const t = buildTranslate('insights_lab.report_item')

  return (
    <div
      data-testid="report-item"
      className={css({
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gap: '16px',
        padding: '16px',
        alignItems: 'center',
        borderBottom: `1px solid ${merchantTheme.colors.grey30}`,
      })}
    >
      <div>
        <Label2
          $style={{
            color: merchantTheme.colors.grey70,
            fontWeight: 700,
          }}
        >
          {title}
        </Label2>
        <Text.BodyText5 color="grey70">{description}</Text.BodyText5>
      </div>
      <span className="ml-xs">
        <Link to={`/insights_lab/${id}`} className="body-text-4">
          {t('view_report')}
        </Link>
      </span>
    </div>
  )
}

export default ReportItem
